<template>
  <div class="row items-center no-wrap">
    <div class="col">
      <div class="text-bold">
        Activate Account Reminders
      </div>
      <div class="text-grey-8 q-mt-xs">
        <div v-if="disabledAt">
          Disabled <humanize-time :time="disabledAt" />
        </div>
        <span v-else>
          Send daily reminder email to activate their account.
        </span>
      </div>
    </div>
    <div class="col-auto q-px-md">
      <q-toggle
        :model-value="enabled"
        color="blue"
        :disabled="isLoading"
        @update:model-value="toggle"
      />
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue';
import { User } from '@/type';
import notify from '@/components/notify';
import HumanizeTime from '@/components/HumanizeTime.vue';
import { HasTaskMixin } from '@/mixins';
import { disableSetupReminders, enableSetupReminders } from './user';

interface Data{
  task: Promise<void>|null,
}

export default defineComponent({
  emits: ['update:user'],
  mixins: [HasTaskMixin],
  components: {
    HumanizeTime,
  },
  props: {
    user: {
      type: Object as () => User,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    userId(): number {
      return this.user.id;
    },
    disabledAt(): string|null {
      return this.user.setupReminderDisabledAt;
    },
    enabled(): boolean {
      return this.disabledAt === null;
    },
  },
  methods: {
    toggle() {
      if (this.isLoading) {
        return;
      }
      const enabled = !this.enabled;
      const action = enabled ? enableSetupReminders : disableSetupReminders;
      this.task = action(this.userId).then((user) => {
        this.$emit('update:user', user);
        notify(enabled ? 'Activate account reminders enabled.' : 'Activate account reminders disabled.');
      });
    },
  },
});
</script>
